<template>
  <admin-wrapper title-translation-path="admin.SEWER_ANALYSIS" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'SewerAnalysisSettings',
  components: { AdminWrapper },
  computed: {
    moduleEnabler() {
      return {
        name: 'sewer_analysis_module_enabled',
        translationPath: 'admin.SEWER_ANALYSIS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.SEWER_ANALYSIS') }),
      };
    },
  },
};
</script>
